import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { formatQRTotal } from "../Components/RoundQRDecimals";

moment.locale("es");

const complementoPdf = (values) => {
  const empresa = values.respuestaComplemento.empresa;
  const dataSat = values.respuestaComplemento.dataSat;
  const dataExtra = values.respuestaComplemento.data;

  // Helpers para totales
  const toNumber = (v) => Number(v || 0);
  const tcOrOne = (moneda, tc) => (moneda === 'MXN' ? 1 : (Number(tc) || 1));

  let dd;
  if (dataSat.Version.toString() === '4.0') {
    // ========= 4.0 =========
    const conceptos = dataSat.Conceptos.map((valueConcepto) => {
      return [
        { style: "textoTablaChico", text: valueConcepto.Cantidad, alignment: "right" },
        { text: valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
        { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
        { text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""), style: "textoTablaChico", alignment: "left" },
        { text: dineroDisabledMask(valueConcepto.ValorUnitario), style: "textoTablaChico", alignment: "right" },
        { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "right" },
      ];
    });

    const pagosNodo = (dataSat.Complemento.Any?.[0]?.["Pago20:Pagos"]?.Pago) || [];
    const totalesNodo = dataSat.Complemento.Any?.[0]?.["Pago20:Pagos"]?.Totales;

    // ===== NUEVO: Tabla dinámica de Totales (Pago 2.0) =====
    const totalesEntries = Object.entries(totalesNodo || {})
      .filter(([k, v]) => v != null && v !== "");

    const esMonto = (k) => /^Monto|^Total|Importe/i.test(k); // heurística simple

    const totalesRows = totalesEntries.map(([k, v]) => ([
      { text: k, style: "textoTabla", alignment: "left" },
      { text: esMonto(k) ? dineroDisabledMask(v) : String(v), style: "textoTabla", alignment: "right" },
    ]));

    const totalesTabla = totalesRows.length ? ([
      { text: "Totales (Complemento de Pago)", style: "tableHeader" },
      {
        style: "tableExample",
        table: {
          widths: ["70%", "30%"],
          body: [
            [
              { text: "Clave", style: "tituloTabla" },
              { text: "Valor", style: "tituloTabla" },
            ],
            ...totalesRows,
          ],
        },
        layout: {
          fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
          hLineWidth: () => 1, vLineWidth: () => 1,
          hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) return null;
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) return null;
            return { dash: { length: 2 } };
          },
        },
      }
    ]) : [];

    // Filas de la tabla "Pagos" (Doctos Relacionados) y "Forma de Pago"
    const pagosDoctosRows = [];
    const formaPagoRows = [];
    let totalPago = 0;
    let totalMXN = 0;

    for (const p of pagosNodo) {
      // Forma de Pago (una fila por pago)
      totalPago += toNumber(p.Monto);
      totalMXN += toNumber(p.Monto) * tcOrOne(p.MonedaP, p.TipoCambioP);
      formaPagoRows.push([
        { text: p.FechaPago, style: "textoTabla", alignment: "center" },
        { text: p.FormaDePagoP, style: "textoTabla", alignment: "center" },
        { text: p.MonedaP, style: "textoTabla", alignment: "center" },
        { text: p.TipoCambioP || "", style: "textoTabla", alignment: "center" },
        { text: p.NumOperacion, style: "textoTabla", alignment: "center" },
        { text: dineroDisabledMask(p.Monto), style: "textoTabla", alignment: "right" },
      ]);

      // Pagos -> Doctos Relacionados
      const doctos = Array.isArray(p.DoctoRelacionado) ? p.DoctoRelacionado : [];
      for (const d of doctos) {
        pagosDoctosRows.push([
          { style: "textoTabla", text: d.IdDocumento, alignment: "center" },
          { text: d.folioVenta || "", style: "textoTabla", alignment: "center" },
          { text: d.MonedaDR, style: "textoTabla", alignment: "center" },
          { text: d.NumParcialidad, style: "textoTabla", alignment: "center" },
          { text: dineroDisabledMask(d.ImpSaldoAnt), style: "textoTabla", alignment: "right" },
          { text: dineroDisabledMask(d.ImpPagado), style: "textoTabla", alignment: "right" },
          { text: dineroDisabledMask(d.ImpSaldoInsoluto), style: "textoTabla", alignment: "right" },
        ])
      }
    }

    totalMXN = (totalesNodo && totalesNodo.MontoTotalPagos != null)
      ? Number(totalesNodo.MontoTotalPagos)
      : totalMXN;

    // Fila TOTAL en Forma de Pago
    if (formaPagoRows.length > 0) {
      formaPagoRows.push([
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "TOTAL", style: "tituloTabla", alignment: "right" },
        { text: dineroDisabledMask(totalPago), style: "tituloTabla", alignment: "right" },
      ]);
    }

    let observaciones = {}
    if (values.imprimirObservaciones && values.observaciones) {
      observaciones = {
        table: {
          widths: ['*'],
          body: [
            [
              {
                border: [true, true, true, false],
                text: "Observaciones:",
                margin: [0, 0, 0, 5],
                style: "header",
              },
            ],
            [
              {
                border: [true, false, true, true],
                text: values.observaciones,
                margin: [0, 0, 0, 5],
                style: "textoChico",
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 1 : 1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 1;
          },
          hLineColor: function (i, node) {
            return "#adaaaa";
          },
          vLineColor: function (i, node) {
            return "#adaaaa";
          },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) {
              return null;
            }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) {
              return null;
            }
            return { dash: { length: 2 } };
          },
        },
      };
    }

    const totalqr = formatQRTotal(dataSat.Total)
    let cadena8 = dataExtra.selloCFDI
    cadena8 = cadena8.slice(-8)
    const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${dataExtra.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`

    // Moneda para cantidad con letra (tomo la del primer pago si existe)
    const monedaLetra = pagosNodo?.[0]?.MonedaP || dataSat.Moneda || 'MXN';

    dd = {
      content: [
        // Encabezado
        {
          style: "tableExample",
          table: {
            widths: ["18%", "52%", "30%"],
            layout: { defaultBorder: false },
            body: [
              [
                { border: [false, false, false, false], image: "logo", fit: [80, 80] },
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],
                    body: [
                      [{ text: (empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : (empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno))), style: "tableHeader" }],
                      [{ text: "R.F.C: " + empresa.rfc, style: "textoChico", alignment: "center" }],
                      [{ text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : ""), style: "textoChico", alignment: "center" }],
                      [{ text: empresa.colonia.tipoAsentamiento + " " + empresa.colonia.nombre + " C.P. " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.estado.abreviatura + " " + empresa.pais.abreviatura + " ", style: "textoChico", alignment: "center" }],
                      [{ text: "Regimen Fiscal: (" + empresa.regimenFiscal.c_RegimenFiscal + ") " + empresa.regimenFiscal.descripcion, style: "textoChico", alignment: "center" }],
                      [{ text: "Tipo De Comprobante: (P) Pago", style: "textoChico", alignment: "center" }],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],
                    body: [
                      [{ text: "N° Complemento de Pago:", style: "subheader", alignment: "center" }],
                      [{ text: dataSat.Serie + ' - ' + dataSat.Folio, style: "textoChico", alignment: "center" }],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
            ],
          },
        },
        // Receptor / Datos
        {
          style: "tableExample",
          table: {
            widths: ["60%", "40%"],
            layout: { defaultBorder: false },
            body: [
              [
                {
                  table: {
                    widths: ["30%", "70%"],
                    layout: { defaultBorder: false },
                    body: [
                      [{ text: "Nombre del cliente :", style: "subheader" }, { text: dataSat.Receptor.Nombre, style: "textoChico" }],
                      [{ text: "R.F.C :", style: "subheader" }, { text: dataSat.Receptor.Rfc, style: "textoChico" }],
                      [{ text: "Uso de CFDI:", style: "subheader" }, { text: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion, style: "textoChico" }],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  table: {
                    widths: ["40%", "60%"],
                    layout: { defaultBorder: false },
                    body: [
                      [{ text: "Fecha:", style: "subheader" }, { text: moment(dataSat.Fecha).locale("es").format("LL"), style: "textoChico" }],
                      [{ text: "Lugar de expedicion:", style: "subheader" }, { text: dataSat.LugarExpedicion, style: "textoChico" }],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Conceptos
        { text: "Concepto", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["7%", "8%", "10%", "50%", "10%", "15%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Cantidad", style: "tituloTabla" },
                { text: "Unidad", style: "tituloTabla" },
                { text: "Calve SAT", style: "tituloTabla" },
                { text: "Descripción", style: "tituloTabla" },
                { text: "P/U", style: "tituloTabla" },
                { text: "Importe", style: "tituloTabla" },
              ],
              ...conceptos
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Pagos (Doctos)
        { text: "Pagos", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["26%", "8%", "8%", "10%", "16%", "16%", "16%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Documento UUID", style: "tituloTabla" },
                { text: "Folio", style: "tituloTabla" },
                { text: "Moneda DR", style: "tituloTabla" },
                { text: "Parcialidad", style: "tituloTabla" },
                { text: "Importe saldo anterior", style: "tituloTabla" },
                { text: "Importe pagado", style: "tituloTabla" },
                { text: "Importe saldo insoluto", style: "tituloTabla" },
              ],
              ...pagosDoctosRows
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Forma de Pago (múltiples filas + TOTAL)
        { text: "Forma De Pago", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["18%", "16%", "12%", "14%", "16%", "24%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Fecha de Pago", style: "tituloTabla" },
                { text: "Forma de pago", style: "tituloTabla" },
                { text: "Moneda", style: "tituloTabla" },
                { text: "Tipo de Cambio", style: "tituloTabla" },
                { text: "Num. Operacion", style: "tituloTabla" },
                { text: "Total", style: "tituloTabla" },
              ],
              ...(formaPagoRows.length ? formaPagoRows : [[
                { text: "", style: "textoTabla" },
                { text: "", style: "textoTabla" },
                { text: "", style: "textoTabla" },
                { text: "", style: "textoTabla" },
                { text: "", style: "textoTabla" },
                { text: dineroDisabledMask(0), style: "textoTabla", alignment: "right" },
              ]]),
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        ...totalesTabla,
        // ===== NUEVO: Total MXN hasta abajo =====
        {
          table: {
            widths: ["*", "auto"],
            body: [
              [
                { text: "", border: [false, false, false, false] },
                { text: "Total de pagos (MXN): " + dineroDisabledMask(totalMXN), style: "tableHeader", border: [false, false, false, false], alignment: "right" }
              ]
            ]
          },
          layout: "noBorders",
          margin: [0, 0, 0, 0]
        },
        // QR + datos bancarios
        {
          style: "tablaSinMargen",
          table: {
            widths: ["24%", "76%"],
            layout: { defaultBorder: true },
            body: [
              [
                { qr: linkqr, alignment: "center", fit: 100, margin: [0, 2, 6, 2] },
                {
                  table: {
                    widths: ["25%", "25%", "25%", "25%"],
                    layout: { defaultBorder: false },
                    body: [
                      [
                        { border: [true, true, false, false], text: "Cuenta Ordenante:", style: "subheaderChico" },
                        { border: [false, true, false, false], text: pagosNodo?.[0]?.CtaOrdenante || "", style: "textoChico", fontSize: 6 },
                        { border: [false, true, false, false], text: "Rfc Ordenante:", style: "subheaderChico" },
                        { border: [false, true, true, false], text: pagosNodo?.[0]?.RfcEmisorCtaOrd || "", style: "textoChico", fontSize: 6 },
                      ],
                      [
                        { border: [true, false, false, false], text: "Banco Ordenante:", style: "subheaderChico" },
                        { border: [false, false, true, false], text: pagosNodo?.[0]?.NomBancoOrdExt || "", style: "textoChico", fontSize: 6, colSpan: 3 }, {}, {}
                      ],
                      [
                        { border: [true, false, false, true], text: "Cuenta Beneficiario:", style: "subheaderChico" },
                        { border: [false, false, false, true], text: pagosNodo?.[0]?.CtaBeneficiario || "", style: "textoChico", fontSize: 6 },
                        { border: [false, false, false, true], text: "Rfc Beneficiario:", style: "subheaderChico" },
                        { border: [false, false, true, true], text: pagosNodo?.[0]?.RfcEmisorCtaBen || "", style: "textoChico", fontSize: 6 },
                      ],
                      [
                        { border: [true, true, false, false], text: "Cantidad con letra:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, true, true, false], text: "**( " + numeroALetra(totalPago, monedaLetra) + " )**", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, false], text: "Moneda:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: dataSat.Moneda, style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, false], text: "Uso de CFDI:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion, style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, true, false, false], text: "Banco:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, true, true, false], text: empresa.banco ? empresa.banco : "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      ...(empresa.swiftCode ? [[
                        { border: [true, false, false, false], text: "Swift Code:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: empresa.swiftCode || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ]] : []),
                      ...(empresa.abaCode ? [[
                        { border: [true, false, false, false], text: "ABA Code:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: empresa.abaCode || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ]] : []),
                      [
                        { border: [true, false, false, false], text: "Cuenta:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: empresa.cuentaBanco || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, true], text: "Cuenta CLABE:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, true], text: empresa.cuentaClabe || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                    ],
                  },
                  layout: {
                    paddingTop: () => 0,
                    paddingBottom: () => 0,
                    paddingLeft: () => 1,
                    paddingRight: () => 1,
                  },
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        observaciones,
        // Sellos / datos SAT
        {
          table: {
            widths: ["15%", "30%", "23%", "32%"],
            layout: { defaultBorder: false },
            body: [
              [{ colSpan: 4, text: '"Este documento es una representacion impresa de un CFDI"', style: "header", alignment: "center" }, {}, {}, {}],
              [{ text: "Folio Fiscal: ", style: "subheaderChico" }, { text: dataExtra.uuid, style: "textoDatoFiscal" }, { text: "Fecha y Hora de Certificación: ", style: "subheaderChico" }, { text: dataSat.Fecha, style: "textoDatoFiscal" }],
              [{ colSpan: 4, text: "Sello digital CFDI: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloCFDI, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 2, text: "Numero de serie del Certificado de Sello digital: ", style: "subheaderChico" }, {}, { colSpan: 2, text: "Numero de serie del Certificado de Sello digital del SAT: ", style: "subheaderChico" }, {}],
              [{ colSpan: 2, text: dataExtra.noCertificadoCFDI, style: "textoChicoData" }, {}, { colSpan: 2, text: dataExtra.noCertificadoSAT, style: "textoChicoData" }, {}],
              [{ colSpan: 4, text: "Cadena Original del complemento de certificación Digital SAT: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.cadenaOriginalSAT, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 4, text: "Sello Digital del SAT: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloSAT, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 4, text: "Sello Digital del CFDI: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloCFDI, style: "textoChicoData" }, {}, {}, {}],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
            paddingLeft: () => 2,
            paddingRight: () => 2,
          },
        },
      ],
      styles: {
        header: { fontSize: 9, bold: true },
        subheader: { fontSize: 8, bold: true },
        subheaderChico: { fontSize: 6, bold: true },
        tableExample: { margin: [0, 5, 0, 5] },
        tablaSinMargen: { margin: [0, 0, 0, 0] },
        tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
        textoChico: { fontSize: 8 },
        textoChicoData: { fontSize: 4 },
        textoDatoFiscal: { fontSize: 8 },
        tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", style: "subheader", alignment: "center", border: true },
        textoTabla: { fontSize: 8, italics: false },
        textoTablaChico: { fontSize: 6, italics: false },
      },
      images: { logo: empresa.logo.base64Completa },
      pageSize: "LETTER",
      defaultStyle: { columnGap: 20 },
    };

  } else if (dataSat.Version.toString() === '3.3') {
    // ========= 3.3 =========
    const conceptos = dataSat.Conceptos.map((valueConcepto) => {
      return [
        { style: "textoTablaChico", text: valueConcepto.Cantidad, alignment: "right" },
        { text: valueConcepto.ClaveUnidad, style: "textoTablaChico", alignment: "center" },
        { text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" },
        { text: valueConcepto.Descripcion + (valueConcepto.Observaciones ? ("\n" + valueConcepto.Observaciones) : ""), style: "textoTablaChico", alignment: "left" },
        { text: dineroDisabledMask(valueConcepto.ValorUnitario), style: "textoTablaChico", alignment: "right" },
        { text: dineroDisabledMask(valueConcepto.Importe), style: "textoTablaChico", alignment: "right" },
      ];
    });

    const pagosNodo = (dataSat.Complemento?.[0]?.Any?.[0]?.["Pago10:Pagos"]?.Pago) || [];
    const totalesNodo = dataSat.Complemento.Any?.[0]?.["Pago20:Pagos"]?.Totales;
    let totalPago = 0;
    let totalMXN = 0;

    // Tabla Pagos (Doctos) – iteramos todos los pagos y todos sus doctos
    const pagosDoctosRows = [];
    for (const p of pagosNodo) {
      totalPago += toNumber(p.Monto);
      totalMXN += toNumber(p.Monto) * tcOrOne(p.MonedaP, p.TipoCambioP);

      const doctos = Array.isArray(p.DoctoRelacionado) ? p.DoctoRelacionado : [];
      for (const d of doctos) {
        pagosDoctosRows.push([
          { style: "textoTabla", text: d.IdDocumento, alignment: "center" },
          { text: d.MonedaDR, style: "textoTabla", alignment: "center" },
          { text: d.MetodoDePagoDR, style: "textoTabla", alignment: "center" },
          { text: d.NumParcialidad, style: "textoTabla", alignment: "center" },
          { text: dineroDisabledMask(p.Monto), style: "textoTabla", alignment: "right" },
          { text: dineroDisabledMask(d.ImpSaldoAnt), style: "textoTabla", alignment: "right" },
          { text: dineroDisabledMask(d.ImpPagado), style: "textoTabla", alignment: "right" },
          { text: dineroDisabledMask(d.ImpSaldoInsoluto), style: "textoTabla", alignment: "right" },
        ])
      }
    }

    // Tabla Forma de Pago (una fila por pago + TOTAL)
    const formaPagoRows = pagosNodo.map((p) => ([
      { text: p.FechaPago, style: "textoTabla", alignment: "center" },
      { text: p.FormaDePagoP, style: "textoTabla", alignment: "center" },
      { text: p.MonedaP, style: "textoTabla", alignment: "center" },
      { text: p.TipoCambioP || "", style: "textoTabla", alignment: "center" },
      { text: p.NumOperacion, style: "textoTabla", alignment: "center" },
      { text: dineroDisabledMask(p.Monto), style: "textoTabla", alignment: "right" },
    ]));

    if (formaPagoRows.length > 0) {
      formaPagoRows.push([
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "", style: "textoTabla" },
        { text: "TOTAL", style: "tituloTabla", alignment: "right" },
        { text: dineroDisabledMask(totalPago), style: "tituloTabla", alignment: "right" },
      ]);
    }

    let observaciones = {}
    if (values.imprimirObservaciones && values.observaciones) {
      observaciones = {
        table: {
          body: [
            [{ border: [true, true, true, false], text: 'Observaciones:', margin: [0, 0, 0, 5], style: 'header' }],
            [{ border: [true, false, true, true], text: values.observaciones, margin: [0, 0, 0, 5], style: 'textoChico' }]
          ],
          layout: {
            defaultBorder: false,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        }
      }
    }

    totalMXN = (totalesNodo && totalesNodo.MontoTotalPagos != null)
      ? Number(totalesNodo.MontoTotalPagos)
      : totalMXN;

    dd = {
      content: [
        // Encabezado
        {
          style: "tableExample",
          table: {
            widths: ["18%", "52%", "30%"],
            layout: { defaultBorder: false },
            body: [
              [
                { border: [false, false, false, false], image: "logo", fit: [80, 80] },
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],
                    body: [
                      [{ text: (empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : (empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno))), style: "tableHeader" }],
                      [{ text: "R.F.C: " + empresa.rfc, style: "textoChico", alignment: "center" }],
                      [{ text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : ""), style: "textoChico", alignment: "center" }],
                      [{ text: empresa.colonia.tipoAsentamiento + " " + empresa.colonia.nombre + " C.P. " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.estado.abreviatura + " " + empresa.pais.abreviatura + " ", style: "textoChico", alignment: "center" }],
                      [{ text: "Regimen Fiscal: (" + empresa.regimenFiscal.c_RegimenFiscal + ") " + empresa.regimenFiscal.descripcion, style: "textoChico", alignment: "center" }],
                      [{ text: "Tipo De Comprobante: (P) Pago", style: "textoChico", alignment: "center" }],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  border: [false, false, false, false],
                  table: {
                    headerRows: 1,
                    widths: ["100%"],
                    body: [
                      [{ text: "N° Complemento de Pago:", style: "subheader", alignment: "center" }],
                      [{ text: dataSat.Serie + ' - ' + dataSat.Folio, style: "textoChico", alignment: "center" }],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
            ],
          },
        },
        // Receptor
        {
          style: "tableExample",
          table: {
            widths: ["60%", "40%"],
            layout: { defaultBorder: false },
            body: [
              [
                {
                  table: {
                    widths: ["30%", "70%"],
                    layout: { defaultBorder: false },
                    body: [
                      [{ text: "Nombre del cliente :", style: "subheader" }, { text: dataSat.Receptor.Nombre, style: "textoChico" }],
                      [{ text: "R.F.C :", style: "subheader" }, { text: dataSat.Receptor.Rfc, style: "textoChico" }],
                      [{ text: "Uso de CFDI:", style: "subheader" }, { text: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion, style: "textoChico" }],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  table: {
                    widths: ["40%", "60%"],
                    layout: { defaultBorder: false },
                    body: [
                      [{ text: "Fecha:", style: "subheader" }, { text: moment(dataSat.Fecha).locale("es").format("LL"), style: "textoChico" }],
                      [{ text: "Lugar de expedicion:", style: "subheader" }, { text: dataSat.LugarExpedicion, style: "textoChico" }],
                    ],
                  },
                  layout: "noBorders",
                },
              ],
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Conceptos
        { text: "Concepto", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["7%", "8%", "10%", "50%", "10%", "15%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Cantidad", style: "tituloTabla" },
                { text: "Unidad", style: "tituloTabla" },
                { text: "Calve SAT", style: "tituloTabla" },
                { text: "Descripción", style: "tituloTabla" },
                { text: "P/U", style: "tituloTabla" },
                { text: "Importe", style: "tituloTabla" },
              ],
              ...conceptos
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Pagos (Doctos)
        { text: "Pagos", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["26%", "8%", "8%", "10%", "12%", "12%", "12%", "12%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Documento UUID", style: "tituloTabla" },
                { text: "Moneda DR", style: "tituloTabla" },
                { text: "Metodo Pago", style: "tituloTabla" },
                { text: "Parcialidad", style: "tituloTabla" },
                { text: "Monto", style: "tituloTabla" },
                { text: "Importe saldo anterior", style: "tituloTabla" },
                { text: "Importe pagado", style: "tituloTabla" },
                { text: "Importe saldo insoluto", style: "tituloTabla" },
              ],
              ...pagosDoctosRows
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // Forma De Pago (múltiples + TOTAL)
        { text: "Forma De Pago", style: "tableHeader" },
        {
          style: "tableExample",
          table: {
            widths: ["18%", "16%", "12%", "14%", "16%", "24%"],
            layout: { defaultBorder: true },
            body: [
              [
                { text: "Fecha de Pago", style: "tituloTabla" },
                { text: "Forma de pago", style: "tituloTabla" },
                { text: "Moneda", style: "tituloTabla" },
                { text: "Tipo de Cambio", style: "tituloTabla" },
                { text: "Num. Operacion", style: "tituloTabla" },
                { text: "Total", style: "tituloTabla" },
              ],
              ...(formaPagoRows.length ? formaPagoRows : [[
                { text: "", style: "textoTabla", alignment: "center" },
                { text: "", style: "textoTabla", alignment: "center" },
                { text: "", style: "textoTabla", alignment: "center" },
                { text: "", style: "textoTabla", alignment: "center" },
                { text: "", style: "textoTabla", alignment: "center" },
                { text: dineroDisabledMask(totalPago), style: "textoTabla", alignment: "right" },
              ]]),
            ],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex % 2 === 0 ? "#f5f5f5" : "#ffffff",
            paddingTop: () => 1, paddingBottom: () => 1,
            hLineWidth: () => 1, vLineWidth: () => 1,
            hLineColor: () => "#adaaaa", vLineColor: () => "#adaaaa",
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 2, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 2 } };
            },
          },
        },
        // ===== NUEVO: Total MXN hasta abajo =====
        {
          table: {
            widths: ["*", "auto"],
            body: [
              [
                { text: "", border: [false, false, false, false] },
                { text: "Total de pagos (MXN): " + dineroDisabledMask(totalMXN), style: "tableHeader", border: [false, false, false, false], alignment: "right" }
              ]
            ]
          },
          layout: "noBorders",
          margin: [0, 0, 0, 0]
        },
        // QR (imagen por clave "qr" ya existente en tu versión 3.3)
        {
          style: "tablaSinMargen",
          table: {
            widths: ["24%", "76%"],
            layout: { defaultBorder: true },
            body: [
              [
                { image: "qr", alignment: "center", width: 90, height: 90, margin: [0, 2, 6, 2] },
                {
                  table: {
                    widths: ["25%", "25%", "25%", "25%"],
                    layout: { defaultBorder: false },
                    body: [
                      [
                        { border: [true, true, false, false], text: "Cuenta Ordenante:", style: "subheaderChico" },
                        { border: [false, true, false, false], text: pagosNodo?.[0]?.CtaOrdenante || "", style: "textoChico", fontSize: 6 },
                        { border: [false, true, false, false], text: "Rfc Ordenante:", style: "subheaderChico" },
                        { border: [false, true, true, false], text: pagosNodo?.[0]?.RfcEmisorCtaOrd || "", style: "textoChico", fontSize: 6 },
                      ],
                      [
                        { border: [true, false, false, false], text: "Banco Ordenante:", style: "subheaderChico" },
                        { border: [false, false, true, false], text: pagosNodo?.[0]?.NomBancoOrdExt || "", style: "textoChico", fontSize: 6, colSpan: 3 }, {}, {}
                      ],
                      [
                        { border: [true, false, false, true], text: "Cuenta Beneficiario:", style: "subheaderChico" },
                        { border: [false, false, false, true], text: pagosNodo?.[0]?.CtaBeneficiario || "", style: "textoChico", fontSize: 6 },
                        { border: [false, false, false, true], text: "Rfc Beneficiario:", style: "subheaderChico" },
                        { border: [false, false, true, true], text: pagosNodo?.[0]?.RfcEmisorCtaBen || "", style: "textoChico", fontSize: 6 },
                      ],
                      [
                        { border: [true, true, false, false], text: "Cantidad con letra:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, true, true, false], text: "**( " + numeroALetra(totalPago, pagosNodo?.[0]?.MonedaP || dataSat.Moneda || 'MXN') + " )**", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, false], text: "Moneda:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: dataSat.Moneda, style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, false], text: "Uso de CFDI:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: "(" + dataSat.usoDeCFDI.c_UsoCFDI + ") " + dataSat.usoDeCFDI.descripcion, style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, true, false, false], text: "Banco:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, true, true, false], text: empresa.banco ? empresa.banco : "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      ...(empresa.swiftCode ? [[
                        { border: [true, false, false, false], text: "Swift Code:", style: "subheaderChico" },
                        { border: [false, false, true, false], text: empresa.swiftCode || "", style: "textoChico", fontSize: 6 },
                      ]] : []),
                      ...(empresa.abaCode ? [[
                        { border: [true, false, false, false], text: "ABA Code:", style: "subheaderChico" },
                        { border: [false, false, true, false], text: empresa.abaCode || "", style: "textoChico", fontSize: 6 },
                      ]] : []),
                      [
                        { border: [true, false, false, false], text: "Cuenta:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, false], text: empresa.cuentaBanco || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                      [
                        { border: [true, false, false, true], text: "Cuenta CLABE:", style: "subheaderChico", colSpan: 2 }, {},
                        { border: [false, false, true, true], text: empresa.cuentaClabe || "", style: "textoChico", fontSize: 6, colSpan: 2 }, {}
                      ],
                    ],
                  },
                  layout: {
                    paddingTop: () => 0,
                    paddingBottom: () => 0,
                    paddingLeft: () => 1,
                    paddingRight: () => 1,
                  },
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        observaciones,
        // Sellos / datos SAT
        {
          table: {
            widths: ["15%", "30%", "23%", "32%"],
            layout: { defaultBorder: false },
            body: [
              [{ colSpan: 4, text: '"Este documento es una representacion impresa de un CFDI"', style: "header", alignment: "center" }, {}, {}, {}],
              [{ text: "Folio Fiscal: ", style: "subheaderChico" }, { text: dataExtra.uuid, style: "textoDatoFiscal" }, { text: "Fecha y Hora de Certificación: ", style: "subheaderChico" }, { text: dataSat.Fecha, style: "textoDatoFiscal" }],
              [{ colSpan: 4, text: "Sello digital CFDI: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloCFDI, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 2, text: "Numero de serie del Certificado de Sello digital: ", style: "subheaderChico" }, {}, { colSpan: 2, text: "Numero de serie del Certificado de Sello digital del SAT: ", style: "subheaderChico" }, {}],
              [{ colSpan: 2, text: dataExtra.noCertificadoCFDI, style: "textoChicoData" }, {}, { colSpan: 2, text: dataExtra.noCertificadoSAT, style: "textoChicoData" }, {}],
              [{ colSpan: 4, text: "Cadena Original del complemento de certificación Digital SAT: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.cadenaOriginalSAT, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 4, text: "Sello Digital del SAT: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloSAT, style: "textoChicoData" }, {}, {}, {}],
              [{ colSpan: 4, text: "Sello Digital del CFDI: ", style: "subheaderChico" }, {}, {}, {}],
              [{ colSpan: 4, text: dataExtra.selloCFDI, style: "textoChicoData" }, {}, {}, {}],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0,
            paddingLeft: () => 2,
            paddingRight: () => 2,
          },
        },
      ],
      styles: {
        header: { fontSize: 9, bold: true },
        subheader: { fontSize: 8, bold: true },
        subheaderChico: { fontSize: 6, bold: true },
        tableExample: { margin: [0, 5, 0, 5] },
        tablaSinMargen: { margin: [0, 0, 0, 0] },
        tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
        textoChico: { fontSize: 8 },
        textoChicoData: { fontSize: 4 },
        textoDatoFiscal: { fontSize: 8 },
        tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", style: "subheader", alignment: "center", border: true },
        textoTabla: { fontSize: 8, italics: false },
        textoTablaChico: { fontSize: 6, italics: false },
      },
      images: {
        logo: empresa.logo.base64Completa,
      },
      pageSize: "LETTER",
      defaultStyle: {
        columnGap: 20,
      },
    };
  }

  //Un complemento cancelado se imprime con marca de agua, igual que la factura
  if (dd && values.estado === 0) {
    dd.watermark = { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 };
  }

  return dd;
};

export default complementoPdf;